import { render, staticRenderFns } from "./CategoryFields.vue?vue&type=template&id=2427dbb5&"
import script from "./CategoryFields.vue?vue&type=script&lang=ts&"
export * from "./CategoryFields.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryFields.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports